import _classCallCheck from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/code/addictive-builder-all/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { logger, loadModule, fill, isThenable } from '@sentry/utils';
import { shouldDisableAutoInstrumentation } from './utils/node-utils.js';
/** Tracing integration for node-postgres package */

var Postgres = /*#__PURE__*/function () {
  function Postgres() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Postgres);

    ;

    Postgres.prototype.__init.call(this);

    this._usePgNative = !!options.usePgNative;
  }
  /**
   * @inheritDoc
   */


  _createClass(Postgres, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Postgres.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      if (shouldDisableAutoInstrumentation(getCurrentHub)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log('Postgres Integration is skipped because of instrumenter configuration.');
        return;
      }

      var pkg = loadModule('pg');

      if (!pkg) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Postgres Integration was unable to require `pg` package.');
        return;
      }

      if (this._usePgNative && !_optionalChain([pkg, 'access', function (_2) {
        return _2.native;
      }, 'optionalAccess', function (_3) {
        return _3.Client;
      }])) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error("Postgres Integration was unable to access 'pg-native' bindings.");
        return;
      }

      var _ref = this._usePgNative ? pkg.native : pkg,
          Client = _ref.Client;
      /**
       * function (query, callback) => void
       * function (query, params, callback) => void
       * function (query) => Promise
       * function (query, params) => Promise
       * function (pg.Cursor) => pg.Cursor
       */


      fill(Client.prototype, 'query', function (orig) {
        return function (config, values, callback) {
          var scope = getCurrentHub().getScope();

          var parentSpan = _optionalChain([scope, 'optionalAccess', function (_4) {
            return _4.getSpan;
          }, 'call', function (_5) {
            return _5();
          }]);

          var span = _optionalChain([parentSpan, 'optionalAccess', function (_6) {
            return _6.startChild;
          }, 'call', function (_7) {
            return _7({
              description: typeof config === 'string' ? config : config.text,
              op: 'db'
            });
          }]);

          if (typeof callback === 'function') {
            return orig.call(this, config, values, function (err, result) {
              _optionalChain([span, 'optionalAccess', function (_8) {
                return _8.finish;
              }, 'call', function (_9) {
                return _9();
              }]);

              callback(err, result);
            });
          }

          if (typeof values === 'function') {
            return orig.call(this, config, function (err, result) {
              _optionalChain([span, 'optionalAccess', function (_10) {
                return _10.finish;
              }, 'call', function (_11) {
                return _11();
              }]);

              values(err, result);
            });
          }

          var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);

          if (isThenable(rv)) {
            return rv.then(function (res) {
              _optionalChain([span, 'optionalAccess', function (_12) {
                return _12.finish;
              }, 'call', function (_13) {
                return _13();
              }]);

              return res;
            });
          }

          _optionalChain([span, 'optionalAccess', function (_14) {
            return _14.finish;
          }, 'call', function (_15) {
            return _15();
          }]);

          return rv;
        };
      });
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Postgres';
    }
  }]);

  return Postgres;
}();

Postgres.__initStatic();

export { Postgres };